import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfiguratorService} from '../../../services/configurator/configurator.service';
import SewingPatternProject from '../../../models/sewing-pattern-project.model';
import {PatternShareService} from '../../../services/pattern/pattern-share.service';
import {AlertController, NavController, Platform, ToastController} from '@ionic/angular';
import {Plugins} from '@capacitor/core';
import AnalyticsService from "../../../services/analytics.service";
import FabricInterface from "../../../models/fabric.interface";
const { Toast } = Plugins;

@Component({
    selector: 'app-project-details-page',
    templateUrl: './project-details-page.component.html',
    styleUrls: ['./project-details-page.component.css'],
})
export class ProjectDetailsPageComponent implements OnInit, OnDestroy {

    sewingPatternProject: SewingPatternProject;

    private projectId$;
    private projectId;

    private canShare: boolean;

    constructor(private route: ActivatedRoute,
                private platform: Platform,
                private router: Router,
                private analytics: AnalyticsService,
                private navController: NavController,
                private toastController: ToastController,
                private configuratorService: ConfiguratorService,
                private patternShareService: PatternShareService,
                private alertController: AlertController) {

        this.canShare = this.platform.is('ios');
    }

    ngOnDestroy(): void {
        this.projectId$?.unsubscribe();
    }

    ngOnInit(): void {
        this.sewingPatternProject = null;

        this.projectId$ = this.route.params.subscribe(params => {
            this.projectId = params.projectId;

            this.configuratorService
                .getSavedSewingPatternById(this.projectId)
                .then(project => {
                    this.sewingPatternProject = project;
                });
        });
    }

    share() {
        this.patternShareService.share(this.sewingPatternProject);
    }

    async save() {
        await this.patternShareService.share(this.sewingPatternProject);

        await Toast.show({
            text: 'Wir haben das Schnittmuster in deiner Gallerie gespeichert.',
        });
    }

    async deleteProject() {
        const alert = await this.alertController.create({
            header: 'Design löschen',
            message: 'Willst du dein Design wirklich löschen?',
            buttons: [ {
                text: 'Abbrechen',
                role: 'cancel'
            }, {
                text: 'OK',
                handler: async () => {
                    await this.configuratorService.removeSewingPatternProject(this.sewingPatternProject);
                    await this.navController.navigateBack('/profile');
                }
            }]
        });

        await alert.present();
    }

    get usedFabrics() {
        if (!this.sewingPatternProject) {
            return [];
        }

        return [...(new Set(this.sewingPatternProject.sewingPattern.areas.map(area => area.fabric)))]
            .filter(fabric => !!fabric);
    }

    get shopLink() {
        return 'https://www.lybstes.de/shop/';
    }
}
